export const alarmRulesState = {
    errorCode : 0,
    statusCode : 0,
    alarmRules : [],
    message : '',
    updatedList : [],
    regionList:[],
    lifeguardPerformedDefibrillator:{}
}
